import { initials } from "@/lib/scoring";

// Rows of "cards disagree" holes; tapping a value makes it the official score on every card.
export function CardDiscrepancies({ event, day, gi, discrepancies, updateScores, testPrefix = "score-review" }) {
  const nameOf = (pid) => event.players.find((p) => p.id === pid)?.name || "?";
  const resolve = (d, value) => {
    const g = day.groups[gi];
    const prev = g.scores?.[d.playerId]?.[d.holeIdx] || { strokes: null, fairway: null, gir: null, putts: null };
    const hole = { ...prev, strokes: value };
    const ops = Object.keys(d.values).map((scorerId) => ({ dayId: day.id, groupIdx: gi, playerId: d.playerId, holeIdx: d.holeIdx, scorerId, hole }));
    if (ops.length === 0) ops.push({ dayId: day.id, groupIdx: gi, playerId: d.playerId, holeIdx: d.holeIdx, hole });
    updateScores(ops);
  };
  if (!discrepancies?.length) return null;
  return (
    <div className="space-y-2">
      {discrepancies.map((d) => (
        <div key={`${d.playerId}-${d.holeIdx}`} className="flex flex-wrap items-center gap-2 border-t border-[rgba(27,51,34,0.08)] pt-2" data-testid={`${testPrefix}-diff-${d.playerId}-${d.holeIdx}`}>
          <div className="text-sm min-w-[120px]"><span className="font-mono-metrics text-[color:var(--brass-dark)]">H{d.holeIdx + 1}</span> · {nameOf(d.playerId)}</div>
          <div className="flex flex-wrap gap-1.5">
            {Object.entries(d.values).map(([scorerId, v]) => (
              <button
                key={scorerId}
                data-testid={`${testPrefix}-pick-${d.playerId}-${d.holeIdx}-${scorerId}`}
                onClick={() => resolve(d, v)}
                className={`text-xs rounded-lg px-2.5 py-1.5 border font-mono-metrics ${d.official === v ? "border-[color:var(--brass)] bg-[rgba(197,160,89,0.15)]" : "border-[rgba(27,51,34,0.2)]"}`}
                title={`${nameOf(scorerId)}'s card`}
              >
                <span className="font-sans opacity-70 mr-1">{initials(nameOf(scorerId))}</span>{v}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
